// extracted by mini-css-extract-plugin
export default {"container":"BackgroundLayout_container__nEiwN","coverImage":"BackgroundLayout_coverImage__FZs0R","contentOverlay":"BackgroundLayout_contentOverlay__9Hl6X"};